import { ready } from '~/core'

ready('footerMain', '.footerMain', (footer) => {
  /* scripting for .footerMain, reference it using footer or $(footer)*/
})
